import CalendarIcon from "@atlaskit/icon/core/calendar";
import TagIcon from "@atlaskit/icon/core/tag";
import {twJoin} from "tailwind-merge";
import {AnankeLozenge} from "@vesta/ananke/components/anankeLozenge";
import type {
    EntityProfileMetaChip,
    EntityProfileSummaryConfig,
} from "~/components/entityProfile/types";

function MetaChip({chip}: {chip: EntityProfileMetaChip}) {
    return (
        <div
            className={twJoin(
                "inline-flex max-w-full items-center gap-x-ds-space-050",
                "rounded-[4px] border border-solid border-ds-border",
                "px-ds-space-100 py-ds-space-050",
                "text-xs text-ds-text",
            )}
        >
            <span className="shrink-0 text-ds-icon" aria-hidden>
                {chip.kind === "calendar" ? (
                    <CalendarIcon label="" size="small" />
                ) : (
                    <TagIcon label="" size="small" />
                )}
            </span>
            <span className="min-w-0 truncate">{chip.label}</span>
        </div>
    );
}

/**
 * Compact identity header (status, name, meta chips) for shells without the
 * summary card: the profile aside and the mobile profile page. Summary fields
 * live in the Details tab for both.
 */
export function EntityProfileIdentityBlock({
    summary,
    metaChips = [],
    className,
}: {
    summary: EntityProfileSummaryConfig;
    metaChips?: Array<EntityProfileMetaChip>;
    className?: string;
}) {
    return (
        <div className={twJoin("grid gap-y-ds-space-100 min-w-0", className)}>
            <div className="justify-self-start">
                <AnankeLozenge appearance={summary.statusAppearance ?? "success"}>
                    {summary.statusLabel}
                </AnankeLozenge>
            </div>
            <h2 className="m-0 text-[20px] leading-[24px] font-semibold text-ds-text break-words">
                {summary.title}
            </h2>
            {metaChips.length > 0 ? (
                <div className="flex flex-wrap gap-ds-space-100">
                    {metaChips.map((chip) => (
                        <MetaChip key={chip.id} chip={chip} />
                    ))}
                </div>
            ) : null}
        </div>
    );
}
